export const isExpressConnectSession = (medium) => medium === 'connect-express'
